import { Button, ButtonProps } from '@chakra-ui/react';
import { ICONS } from '~/constants';

type ShowHideButtonProps = ButtonProps & {
  show: boolean;
  onClick: () => void;
  count?: number;
  variant?: 'outline' | 'plain';
  showIcon?: boolean;
};

export const ShowHideButton = ({
  show,
  onClick,
  children,
  count,
  variant = 'outline',
  showIcon = true,
  ...props
}: ShowHideButtonProps) => {
  const labelShowAll = 'Visa alla' + (count !== undefined ? ` (${count})` : '');
  const labelShowLess = 'Visa färre';

  return (
    <Button
      size="sm"
      variant={variant}
      leftIcon={
        variant === 'outline' || !showIcon ? undefined : show ? (
          <ICONS.UP />
        ) : (
          <ICONS.DOWN />
        )
      }
      backgroundColor="transparent"
      onClick={onClick}
      {...props}
    >
      {children || (show ? labelShowLess : labelShowAll)}
    </Button>
  );
};
